import React from 'react';
import ReactDOM from 'react-dom';

import AppProvider from './AppProvider';
import GAService from './services/GAService';

import './styles/main.scss';

GAService.fetchEnv().then(data => {
  const { GTM_ENABLED, GTM_CONTAINER_ID, GTM_AUTH, GTM_PREVIEW } = data || {};
  if (GTM_ENABLED && GTM_CONTAINER_ID && GTM_PREVIEW && GTM_AUTH) {
    GAService.initGA(window, document, 'script', 'dataLayer', {
      id: GTM_CONTAINER_ID,
      gtm_auth: GTM_AUTH,
      gtm_preview: GTM_PREVIEW
    });
  }
});

ReactDOM.render(
  <AppProvider />,
  document.getElementById('root') as HTMLElement
);
